const getLastPathSegment = (path: string) => path.substring(path.lastIndexOf('/') + 1);

export default getLastPathSegment;
